var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9213 14.4997C16.9213 19.1943 13.1334 23 8.46067 23C3.78793 23 0 19.1955 0 14.4997C0 9.80387 3.78793 6 8.46067 6C13.1334 6 16.9213 9.80569 16.9213 14.4997ZM26.2029 14.4997C26.2029 18.9188 24.3087 22.5012 21.9723 22.5012C19.6359 22.5012 17.7417 18.9176 17.7417 14.4997C17.7417 10.0818 19.6366 6.49877 21.9729 6.49877C24.3093 6.49877 26.2036 10.0824 26.2036 14.5003M30 14.5003C30 18.4595 29.3335 21.6693 28.5119 21.6693C27.6904 21.6693 27.0239 18.4589 27.0239 14.5003C27.0239 10.5417 27.6904 7.33126 28.5119 7.33126C29.3335 7.33126 29.9994 10.5411 29.9994 14.5003",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.56cd2249833e102ed10890e0598759e0.svg";
export { ForwardRef as ReactComponent };